export const FETCH_PACKAGE_ORDER_DETAIL_PENDING = "FETCH_PACKAGE_ORDER_DETAIL_PENDING";
export const FETCH_PACKAGE_ORDER_DETAIL_REJECTED = "FETCH_PACKAGE_ORDER_DETAIL_REJECTED";
export const FETCH_PACKAGE_ORDER_DETAIL_FULFILLED = "FETCH_PACKAGE_ORDER_DETAIL_FULFILLED";
export const FETCH_SHIPPING_AMOUNT = "FETCH_SHIPPING_AMOUNT";


// WEBPACK FOOTER //
// ./src/constants/kapidaConstants/packageOrderDetail.js